import React from "react";
import { Skeleton, Space, Typography } from "antd";
import { useTranslation } from "react-i18next";
import styled, { keyframes } from "styled-components";

import LoadingSpinner from "../../../assets/svg/LoadingSpinner";
import { TEXT2 } from "../../../constant/colors";
import { sizes } from "../../../constant/styles";

const { Text } = Typography;

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const SpinningIcon = styled.span`
  display: inline-flex;
  animation: ${spin} 1s linear infinite;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
`;

const StatusLine = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

// Patient-page skeleton shown beneath the retrieval modal while an archived patient is restored.
const RestoringPatientSkeleton = () => {
  const { t } = useTranslation();

  return (
    <div aria-busy="true" data-testid="restoring-patient-skeleton" style={{ padding: 24 }}>
      <Header>
        <StatusLine role="status" aria-live="polite">
          <Text style={{ fontSize: sizes.medium, color: TEXT2 }}>{t("unarchive.header_status")}</Text>
          <SpinningIcon aria-hidden="true">
            <LoadingSpinner />
          </SpinningIcon>
        </StatusLine>
      </Header>
      <Space style={{ marginBottom: 24 }}>
        <Skeleton.Button active size="large" />
        <Skeleton.Button active size="large" />
        <Skeleton.Button active size="large" />
        <Skeleton.Button active size="large" />
        <Skeleton.Button active size="large" />
      </Space>
      <Skeleton active paragraph={{ rows: 12 }} />
    </div>
  );
};

export default RestoringPatientSkeleton;
